import { Lookup } from '../lookup.interface';
export const FollowupAttemptStatusesLimited: { [name: string]: Lookup } = {
  successful: {
    code: 'successful',
    displayValue: 'Successful',
  },
  unableToContact: {
    code: 'unableToContact',
    displayValue: 'Unable to contact',
  },
};
export const FollowupAttemptStatuses: { [name: string]: Lookup } = {
  ...FollowupAttemptStatusesLimited,
  notApplicable: {
    code: 'notApplicable',
    displayValue: 'Not applicable',
  },
};
